/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-case-declarations */
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import style from "../../Styles/mainDashboard.module.css";
import { isMobile } from "../../Utils/utils";

import VINRequests from "./VINRequests";
import { localUrlEnum } from "../../Utils/urlEnum";
import { RolesEnum, vinRequestsStatus } from "../../Utils/Constants";
import { CacheContext } from "../../Context/cacheContext";
import { Vocabulary } from "../../Utils/Vocabulary";
import withRole from "../../Utils/withRole";

export type StateProps = {
  vehicles: Array<any>;
  vehiclesNumber: number;
};

function DashboardVINRequests(props: any) {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [status, setStatus] = useState("");

  const [unassignedRequestsCount, setUnassignedRequestsCount] = useState(0);
  const roles: any = window.localStorage.getItem("roles");
  const isAdmin = roles.includes(RolesEnum.admin);

  const cacheContext = useContext(CacheContext);
  const tabsLabelsArray: any[] = [];

  tabsLabelsArray.push(
    {
      label: Vocabulary.allocated,
      badge: 0,
      code: vinRequestsStatus.Alocate,
    },
    {
      label: Vocabulary.canceled,
      badge: 0,
      code: vinRequestsStatus.Anulate,
    }
  );

  //select what tabs to include
  if (isAdmin || props.info)
    //show all requests only for admin
    tabsLabelsArray.push({
      label: Vocabulary.all,
      badge: 0,
      code: vinRequestsStatus.Toate,
    });

  //show unassigned requests
  tabsLabelsArray.push({
    label: Vocabulary.unallocated,
    badge: unassignedRequestsCount,
    code: vinRequestsStatus.Nealocate,
  });

  /**
   *
   */
  useEffect(() => {
    getUrlVehicles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const getUrlVehicles = () => {
    const params = new URLSearchParams(location.search);
    setStatus(params.get("status") || tabsLabelsArray[0].code);
    setValue(params.get("index") ? Number(params.get("index")) : 0);
  };

  /**
   *
   * @param event
   * @param index
   */
  const handleChange = (_event: any, index: number) => {
    const statusCode = tabsLabelsArray[index].code;
    setStatus(statusCode);
    setValue(index);
    const currentParams = new URLSearchParams(location.search);
    currentParams.set("status", statusCode);
    currentParams.set("index", String(index));
    navigate(`${localUrlEnum.vinRequests}?${currentParams.toString()}`);
  };

  return (
    <div
      style={{ display: "flex", flexDirection: isMobile() ? "column" : "row" }}
    >
      <div className={style.mainTable}>
        {
          <VINRequests
            value={value}
            accesForAllMessages={props.info}
            getDataRefresh={getUrlVehicles}
            handleChange={handleChange}
            status={status}
            tabsLabelsArray={tabsLabelsArray}
            setUnassignedRequestsCount={setUnassignedRequestsCount}
            cacheContext={cacheContext}
            isAdmin={isAdmin}
          ></VINRequests>
        }
      </div>
    </div>
  );
}

export default withRole(DashboardVINRequests);
